export const theme = {
  primaryColor: 'blue',
  accentColor: '#007FEC'
}